/**
 * Created by staffanrantzow on 17/03/16.
 */

import * as types from './action-types';

const menuState = (state = 'closed', action) => {
  switch (action.type) {
    case types.OPEN_MAIN_MENU :
      return 'open';
    case types.CLOSE_MAIN_MENU :
      return 'closed';
    default:
      return state;
  }
};

export default menuState;



/** WEBPACK FOOTER **
 ** ./src/redux/modules/main-menu/reducer.js
 **/